export default "__VITE_ASSET__BBvYk79V__"